<template>
    <div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div id="staleAssembliesTodos" class="todo-category accordion-item">
                <div class="accordion-header-container">
                    <div class="accordion-header">
                        <button class="accordion-button collapsed" type="button"
                                data-bs-toggle="collapse" data-bs-target="#staleAssembliesTodo"
                                aria-expanded="false" aria-controls="staleAssembliesTodo">
                                <span class="round-icon bg-purple text-white me-3">
                                    <i class="fa fa-edit"></i>
                                </span>

                            <span class="title">Openstaande montage</span>
                            <span class="ms-auto badge amount rounded-pill text-bg-primary">
                                {{ this.count }}
                            </span>
                        </button>
                    </div>
                </div>

                <div id="staleAssembliesTodo" class="accordion-collapse collapse" data-bs-parent="#todos">
                    <div class="accordion-body">

                        <div class="row mt-2" style="padding: 0.5rem 1rem;">
                            <div class="col-md-5">
                                <!-- Date From -->
                                <div class="mb-2">
                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="dateFrom"
                                        placeholder="Selecteer startdatum"
                                    >
                                </div>
                            </div>
                            <div class="col-md-5">
                                <!-- Date Till -->
                                <div class="mb-2">
                                    <input
                                        type="date"
                                        class="form-control"
                                        v-model="dateTill"
                                        placeholder="Selecteer einddatum"
                                    >
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <button
                                        class="btn btn-primary ms-auto px-3 py-2 text-sm"
                                        @click="getStaleAssemblies()"
                                    >
                                        Filter <i class="fa fa-filter" :class="{ 'fa fa-circle-o-notch fa-spin' : this.btnActionLoader }"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div v-for="item in this.staleAssemblies" class="todo">
                            <div class="todo-data">
                                <div class="col-170">
                                    <p class="mb-0">
                                        {{ item.order_id }} | {{ item.name }}
                                    </p>
                                </div>
                                <div class="col-170">
                                    <p v-html="item.price" class="mb-0"></p>
                                </div>
                                <div class="date">
                                    <p class="mb-0">
                                        <i class="fa fa-calendar-o"></i>
                                        {{ item.last_assembly_date }}
                                    </p>
                                </div>
                            </div>
                            <div class="actions ms-auto">
                                <a v-if="item.order_type == 'order'" :href="'assemblies/show/order/'+item.order_id" target="_blank">
                                    <i class="fa fa-external-link"></i>
                                </a>
                                <a v-if="item.order_type == 'order-project'" :href="'assemblies/show/order-project/'+item.order_id" target="_blank">
                                    <i class="fa fa-external-link"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'todos-stale-assemblies',
    components: {},
    props: {},
    data() {
        return {
            staleAssemblies: [{
                key: {
                    last_assembly_date: '',
                    name: '',
                    order_id: '',
                    order_type: '',
                }
            }],
            count: 0,
            dateFrom: '',
            dateTill: '',
            loading: true,
            btnActionLoader: false,
        }
    },
    computed: {},
    watch: {},
    methods: {
        getStaleAssemblies() {

            this.btnActionLoader = true;

            axios.get('api/todo-stale-assemblies?date_from=' + this.dateFrom + '&date_till=' + this.dateTill)
                .then(response => {
                    this.staleAssemblies = response.data.staleAssemblies;
                    this.count = response.data.count;
                    this.dateFrom = response.data.dateFrom;
                    this.dateTill = response.data.dateTill;
                    this.loading = false;
                    this.btnActionLoader = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },

    },
    mounted() {
        this.getStaleAssemblies();
    },
    created() {},
}
</script>
